export enum QUERY_KEYS {
  getFormFields = 'form-fields',
}
